import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import VMSvg from '../../../assets/icons/app/vm.svg?raw';

export const VMIcon = (props) => <CustomSVG svg={VMSvg} preserveColors appIconSmall {...props} />;
